import React from 'react';
import { Bird, Egg, Zap, Star, Thermometer, Settings, Shield, Leaf } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Bird, Egg, Zap, Star, Thermometer, Settings, Shield, Leaf
};

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-3 bg-white border-2 border-emerald-200 rounded-2xl px-6 py-4 mb-6 shadow-lg">
            <img 
              src="/logo.jpeg" 
              alt="Four Pillars Global LLP" 
              className="h-16 w-auto object-contain"
            />
            <div className="text-left">
              <div className="text-2xl font-bold text-emerald-800">Eggfy</div>
              <div className="text-xs text-emerald-600">Premium Egg Brand</div>
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {mockData.about.title}
          </h2>
          <p className="text-xl text-emerald-700 font-medium mb-4">
            {mockData.about.subtitle}
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            {mockData.about.description}
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {mockData.about.stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg border border-emerald-100 hover:shadow-xl transition-all hover:scale-105 group"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="text-emerald-700" size={28} />
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-1">{stat.value}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            );
          })}
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {mockData.about.features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 hover:shadow-xl transition-all group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-emerald-600 to-emerald-800 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Icon className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Certifications */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg border border-emerald-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Certifications & Standards
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {mockData.certifications.map((cert, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                  <Shield className="text-emerald-700" size={32} />
                </div>
                <div className="font-bold text-gray-900">{cert.name}</div>
                <div className="text-sm text-gray-600">{cert.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
